import { render, staticRenderFns } from "./UnlinkCasesFromHistory.vue?vue&type=template&id=fd5459ee&scoped=true&"
import script from "./UnlinkCasesFromHistory.vue?vue&type=script&lang=js&"
export * from "./UnlinkCasesFromHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5459ee",
  null
  
)

export default component.exports